import AdminCrud from "@/components/AdminCrud";

export default function AdminNews() {
  return (
    <AdminCrud
      endpoint="/news"
      singular="article"
      testIdPrefix="admin-news"
      listColumns={[
        { key: "title", label: "Title" },
        { key: "author", label: "Author" },
        { key: "published", label: "Published" },
      ]}
      fields={[
        { key: "title", label: "Title", type: "text", required: true, colSpan: 2 },
        { key: "author", label: "Author", type: "text", required: true },
        { key: "published", label: "Published", type: "date", required: true },
        { key: "image_url", label: "Image URL", type: "text", colSpan: 2 },
        { key: "excerpt", label: "Excerpt", type: "textarea", required: true, colSpan: 2, rows: 3 },
        { key: "body", label: "Body", type: "textarea", required: true, colSpan: 2, rows: 10 },
      ]}
    />
  );
}
